export interface IOHLC {
  open: number | string
  high: number | string
  low: number | string
  close: number | string
  volume: number | string
  startTime: string | Date
  endTime: string | Date
  exchCode: string
}

export class OHLC implements IOHLC {
  constructor(
    public open: number | string = '',
    public high: number | string = '',
    public low: number | string = '',
    public close: number | string = '',
    public volume: number | string = '',
    public startTime: string | Date = '',
    public endTime: string | Date = '',
    public exchCode: string = ''
  ) {}
}

export default OHLC 